import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantContextService } from './tenant-context.service';

export const tenantContextInterceptor: HttpInterceptorFn = (req, next) => {
  const service = inject(TenantContextService);
  const tenant = service.getTenant();

  if (tenant) {
    req = req.clone({
      headers: req.headers.set('AlliantShip-Tenant-Id', tenant),
    });
  }

  return next(req);
};
